export default class EventModel {
  ItemCode;
  eventCode;
  eventName;
  startDate;
  startTime;
  endDate;
  endTime;
  eventType;
  discountType;
  discountAmount;
  discountRate;
  eventPrice;

  constructor(data) {
    Object.assign(this, data);
  }
}
